export default "__VITE_ASSET__BduWqNaG__"